/**
 * @Author: wuyang
 * @Date: 2024/1/11
 * @Description: ""
 */
import { EBizPhone } from '@/types/bizPhone'

export enum ETaskStatus {
	editing = 0, // 编辑中
	success = 1, // 成功
	fail = 2, // 失败
	execute = 3, // 执行中
	queue = 4, // 排队中
	ai = 5, // AI 处理中
	modifying = 6 // 修改中

}

// 任务描述类型(0-快捷描述,1-预设模块，2-高级描述)
export enum ETaskDescType {
	shot = '0',
	preset = '1',
	advanced = '2'
}

// 任务切割图接口信息
export interface ITaskSeg {
	width: number
	height: number
	proceing: number
	mask_list: { index: number; mask: string }[]
}

// 裁剪后推送结果
export interface ITaskCropping {
	description:string
	frameCoordinates:string
	markImgUrl: string
	originalUrl: string
}


// 任务详情接口信息
export interface ITask {
	// 任务 id
	taskId: string
	taskOrdinalId: string
	// 任务名称
	taskName: string
	// 任务执行状态
	status: ETaskStatus
	// 冗余字段
	createBy: string

	// 人台图，快捷描述和高级描述 是否选择时真人 0 表示非真人，1 表示 真人
	realPerson: 0 | 1

	// 人台图，快捷描述和高级描述 是否选择修复图片 0 表示不修复，1 表示 修复
	repair: 0 | 1

	// 创建时间
	createTime: string

	// 任务描述类型
	desType: ETaskDescType

	// 执行时间
	executeTime: string

	// 原始图片
	originalUrl: string
	
	// 裁剪图片
	markImgUrl: string

	// 任务来源相关 id
	referedTaskId: string
	// 每次执行的任务列表
	taskOrdinalList: Array<ITaskResultItem>
	// 任务商拍类型
	type: EBizPhone
	// 冗余字段
	updateBy: string

	// 更新时间
	updateTime: string

	// 创建用户 id
	userId: string

  // 任务描述状态
  descStatus:string

  //截图框信息
  frameCoordinates:string | null

  // 任务描述
  description:string | null,

}

export interface ITaskListItem
	extends Pick<
		ITask,
		'taskId' | 'taskName' | 'status' | 'updateTime' | 'originalUrl'
	> {}

// 任务执行单项结果
export interface ITaskResultItem {
	taskId: string
	taskOrdinalId: string
	type: EBizPhone
	// 人台图，快捷描述和高级描述 是否选择时真人 0 表示非真人，1 表示 真人
	realPerson: 0 | 1
	// 人台图，快捷描述和高级描述 是否选择修复图片 0 表示不修复，1 表示 修复
	repair: 0 | 1
	// 任务描述类型
	desType: ETaskDescType
	// 执行时间
	updateTime: string
	// 模版图片
	markImgUrl: string
	// 原图片
	originImgUrl: string
	// 来源 Id
	referedTaskId?: string
	// 来源任务序号ID
	referedTaskOrdinalId?: string

	// seed > 0 是说明有随机种子
	seed?: number
	// 预计排队等待时间
	waitTime?: number
	status: ETaskStatus
	// 前端存储额外的字符串，通常是 JSON.stringify
	extra: string

	// 执行序号
	ordinal: number
	// 返回图片列表
	ordinalImgResultList: ITaskResultImage[]

	// 快捷描述
	prompt?: string

	// 高级描述
	forward?: string
	reverse?: string
	weight?: number

	// 人台预设信息
	modelUploadUrl?: string
	webCharacterModel?: {
		prompt: string
		id: string
		params: Array<{ key: string; value: string }>
		image?: string
	}
	webScenRealHuman?: {
		categoryLarge: string
		categorySmall: string
		prompt: string
		id: string
	}

	// 商品预设信息
	webScenGoodsCategorySub?: {
		category: string
		categorySub: string
		prompt: string
		id: string
	}

	// 模特特征id信息
	optionalCharacterIds: string
}

// 任务执行结果中图片的数据结构
export interface ITaskResultImage {
	imageId: string
	resImgUrl: string
	resSmallImgUrl: string
	markImgUrl: string
	follow: number
	zan: number
	progress: number
	queue: number
	taskOrdinalId: string
	taskId: string
	originalImgUrl: string
	ordinal: number
	type: EBizPhone
	extra: string
	seed: number
}

// 任务执行数据类型
export interface ITaskExecuteParams
	extends Pick<
		ITaskResultItem,
		| 'taskId'
		| 'type'
		| 'desType'
		| 'waitTime'
		| 'markImgUrl'
		| 'originImgUrl'
		| 'referedTaskId'
		| 'referedTaskOrdinalId'
		| 'prompt'
		| 'forward'
		| 'reverse'
		| 'weight'
		| 'modelUploadUrl'
		| 'webCharacterModel'
		| 'webScenRealHuman'
		| 'webScenGoodsCategorySub'
		| 'extra'
	> {
	realPerson?: 0 | 1
	repair?: 0 | 1
	optionalCharacterIds?: string   //模特特征id
}

export interface IModelSpellListItem {
	id: string
	characteristic: string
	vaCh: string
	vaEn: string
}

export interface IModelSpellList {
	characteristic: string
	data: IModelSpellListItem[]
}

export interface IModalFeatureItem {
	characteristic: string
	id: number
	image: string
	vaCh: string
	vaEn: string
}

export interface IModalFeatureList {
	characteristic: string
	data: IModalFeatureItem[]
}
